// src/services/leaveService.js

import api from "./api_client";

const leaveService = {

  // ============================================================
  // TYPES DE CONGÉS
  // ============================================================

  getLeaveTypes: async () => {
    const response = await api.get("/leave-types");
    return response.data;
  },

  // ============================================================
  // SOLDES
  // ============================================================

  getLeaveBalancesMe: async () => {
    const response = await api.get("/leave-balances/me");
    return response.data;
  },

  // ============================================================
  // MES DEMANDES
  // ============================================================

  getLeaveRequestsMe: async () => {
    const response = await api.get("/leave-requests/me");
    return response.data;
  },
getLeaveTypes: async () => {
    const response = await api.get("/leave-types");
    return response.data;
  },

  getLeaveBalancesMe: async () => {
    const response = await api.get("/leave-balances/me");
      console.log("[Soldes congés] Réponse backend :", response.data);
    return response.data;
  },

  getLeaveRequestsMe: async () => {
    const response = await api.get("/leave-requests/me");
    return response.data;
  },

  getAllLeaveRequests: async () => {
    const response = await api.get("/leave-requests");
      console.log("[LeaveService] Réponse API :", response.data);
    return response.data;
  },

  getLeaveRequestsManager: async (status = null) => {
    const params = status ? { status } : {};
    const response = await api.get("/leave-requests/manager", { params });
    return response.data;
  },

  getLeaveRequestsRH: async () => {
    const response = await api.get("/leave-requests/rh");
    return response.data;
  },

  // ============================================================
  // CRÉATION D'UNE DEMANDE
  // ============================================================

  
createLeaveRequest: async (data, file = null) => {
  const formData = new FormData();

  formData.append(
    "leave_type_id",
    String(data.leave_type_id)
  );

  formData.append("start_date", data.start_date);
  formData.append("end_date", data.end_date);
  formData.append("day_part", data.day_part || "FULL_DAY");
  formData.append("reason", data.reason || "");

  if (file instanceof File) {
    formData.append("file", file);
  }

  console.log("========== CREATE LEAVE ==========");

  for (const [key, value] of formData.entries()) {
    console.log(
      key,
      value instanceof File
        ? `${value.name} (${value.size} bytes)`
        : value
    );
  }

  const response = await api.post(
    "/leave-requests",
    formData
  );

  return response.data;
},


  // ============================================================
  // MODIFICATION PAR L'EMPLOYÉ
  // ============================================================

  employeeEditRequest: async (
    requestId,
    data,
    file = null
  ) => {

    const formData = new FormData();

    formData.append(
      "leave_type_id",
      String(data.leave_type_id)
    );

    formData.append(
      "start_date",
      data.start_date
    );

    formData.append(
      "end_date",
      data.end_date
    );

    formData.append(
      "day_part",
      data.day_part || "FULL_DAY"
    );

    formData.append(
      "reason",
      data.reason || ""
    );

    if (file instanceof File) {
      formData.append("file", file);
    }

    console.log(
      "========== EMPLOYEE EDIT =========="
    );

    console.log("requestId:", requestId);
    console.log("leave_type_id:", data.leave_type_id);
    console.log("start_date:", data.start_date);
    console.log("end_date:", data.end_date);
    console.log("day_part:", data.day_part);
    console.log("reason:", data.reason);
    console.log("file:", file);

    for (const [key, value] of formData.entries()) {

      console.log(
        `${key}:`,
        value instanceof File
          ? `${value.name} (${value.size} bytes)`
          : value
      );
    }

    /*
     * IMPORTANT :
     * Ne pas mettre manuellement :
     *
     * headers: {
     *   "Content-Type": "multipart/form-data"
     * }
     *
     * Le navigateur/Axios ajoute automatiquement
     * la boundary multipart.
     */

    const response = await api.put(
      `/leave-requests/${requestId}/employee-edit`,
      formData
    );

    return response.data;
  },

  // ============================================================
  // MODIFICATION RH
  // ============================================================

  hrEditRequest: async (
    requestId,
    data,
    file = null
  ) => {

    const formData = new FormData();

    formData.append(
      "leave_type_id",
      String(data.leave_type_id)
    );

    formData.append(
      "start_date",
      data.start_date
    );

    formData.append(
      "end_date",
      data.end_date
    );

    formData.append(
      "day_part",
      data.day_part || "FULL_DAY"
    );

    formData.append(
      "reason",
      data.reason || ""
    );

    if (file instanceof File) {
      formData.append("file", file);
    }

    const response = await api.put(
      `/leave-requests/${requestId}/hr-edit`,
      formData
    );

    return response.data;
  },

  // ============================================================
  // CALCUL DES JOURS
  // ============================================================

  calculateLeaveDays: async (startDate, endDate, dayPart = "FULL_DAY") => {
    const response = await api.post("/leave-requests/calculate-days", {
      start_date: startDate,
      end_date: endDate,
      day_part: dayPart,
    });
    return response.data;
  },
  // ============================================================
  // ANNULATION
  // ============================================================

  cancelLeaveRequest: async (requestId) => {

    const response = await api.put(
      `/leave-requests/${requestId}/cancel`
    );

    return response.data;
  },

  downloadAttachment: async (requestId) => {
    const response = await api.get(`/leave-requests/${requestId}/attachment`, {
      responseType: "blob",
    });
    return response.data;
  },
 uploadAttachment: async (requestId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/leave-requests/${requestId}/attachment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  deleteAttachment: async (requestId) => {
    const response = await api.delete(`/leave-requests/${requestId}/attachment`);
    return response.data;
  },

  getApprovedHistory: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.year) params.append("year", filters.year);
    if (filters.month) params.append("month", filters.month);
    if (filters.leave_type_id) params.append("leave_type_id", filters.leave_type_id);
    if (filters.employee_id) params.append("employee_id", filters.employee_id);
    
    const response = await api.get(`/leave-requests/approved-history?${params.toString()}`);
    return response.data;
  },

  getAdditionalAttachments: async (requestId) => {
    const response = await api.get(`/leave-requests/${requestId}/attachments`);
    return response.data;
  },


 

  uploadAdditionalAttachment: async (requestId, file, description = "") => {
    if (!requestId || !file) {
      throw new Error("La demande et le fichier sont obligatoires.");
    }

    const formData = new FormData();
    formData.append("file", file);

    if (description.trim()) {
      formData.append("description", description.trim());
    }

    try {
      const response = await api.post(
        `/leave-requests/${requestId}/attachments`,
        formData
      );

      return response.data;
    } catch (error) {
      console.error(
        "[UPLOAD ATTACHMENT] Erreur backend :",
        error.response?.data || error.message
      );
      throw error;
    }
  },


  downloadLeavePdf: async (requestId) => {
    const response = await api.get(`/leave-requests/${requestId}/pdf`, {
      responseType: "blob",
    });
    return response.data;
  },

   getLeaveRequestsManager: async (status = null) => {
    const params = status ? { status } : {};
    const response = await api.get("/leave-requests/manager", { params });
    return response.data;
  },

  getLeaveRequestsRH: async () => {
    const response = await api.get("/leave-requests/rh");
    return response.data;
  },

  managerDecision: async (id, approved, comment = "") => {
    const response = await api.put(`/leave-requests/${id}/manager-decision`, {
      approved,
      comment,
    });
    return response.data;
  },

hrDecision: async (requestId, approved, comment) => {
  console.log("[leaveService] hrDecision", {
    requestId,
    approved,
    approvedType: typeof approved,
    comment,
  });

  const response = await api.put(
    `/leave-requests/${requestId}/hr-decision`,
    {
      approved: Boolean(approved),
      comment,
    }
  );

  console.log("[leaveService] Réponse HTTP :", response.status);
  console.log("[leaveService] Données reçues :", response.data);

  return response.data;
},

  getHolidays: async (year = null, holidayType = null) => {
    const params = {};
    if (year) params.year = year;
    if (holidayType) params.holiday_type = holidayType;
    const response = await api.get("/leave-requests/holidays", { params });
    return response.data;
  },

  getHolidayById: async (holidayId) => {
    const response = await api.get(`/leave-requests/holidays/${holidayId}`);
    return response.data;
  },

  createHoliday: async (holidayData) => {
    const response = await api.post("/leave-requests/holidays", holidayData);
    return response.data;
  },

  updateHoliday: async (holidayId, holidayData) => {
    const response = await api.put(`/leave-requests/holidays/${holidayId}`, holidayData);
    return response.data;
  },

  deleteHoliday: async (holidayId) => {
    const response = await api.delete(`/leave-requests/holidays/${holidayId}`);
    return response.data;
  },

 updateLeaveBalance: async (id, recoveryBalance) => {
  const response = await api.put(`/leave-balances/${id}`, {
    recovery_balance: Number(recoveryBalance),
  });

  return response.data;
},

  triggerAccrual: async () => {
    const response = await api.post("/leave-balances/accrual");
    return response.data;
  },


  getRequestHistory: async (requestId) => {
    const response = await api.get(`/leave-requests/${requestId}/history`);
    return response.data;
  },

  getApprovedHistory: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.year) params.append("year", filters.year);
    if (filters.month) params.append("month", filters.month);
    if (filters.leave_type_id) params.append("leave_type_id", filters.leave_type_id);
    if (filters.employee_id) params.append("employee_id", filters.employee_id);
    
    const response = await api.get(`/leave-requests/approved-history?${params.toString()}`);
    return response.data;
  },

  getAdditionalAttachments: async (requestId) => {
    const response = await api.get(`/leave-requests/${requestId}/attachments`);
    return response.data;
  },

  /*uploadAdditionalAttachment: async (requestId, file, description = "") => {
    const formData = new FormData();
    formData.append('file', file);
    if (description) formData.append('description', description);
    
    const response = await api.post(`/leave-requests/${requestId}/attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },*/

  editMyLeaveRequest: async (requestId, data, file = null) => {
  const formData = new FormData();

  formData.append("start_date", data.start_date);
  formData.append("end_date", data.end_date);
  formData.append(
    "day_part",
    data.day_part || "FULL_DAY"
  );
  formData.append(
    "reason",
    data.reason || ""
  );

  if (file instanceof File) {
    formData.append("file", file);
  }

  const response = await api.put(
    `/leave-requests/${requestId}/employee-edit`,
    formData
  );

  return response.data;
},

downloadAdditionalAttachment: async (attachmentId) => {
  try {
    const response = await api.get(
      `/leave-attachments/${attachmentId}/download`,
      { responseType: "blob" }
    );

    return response.data;
  } catch (error) {
    console.error("Échec téléchargement :", {
      status: error.response?.status,
      url: error.config?.url,
      data: error.response?.data,
      message: error.message,
    });

    throw error;
  }
},

deleteAdditionalAttachment: async (attachmentId) => {
  const response = await api.delete(
    `/leave-attachments/${attachmentId}`
  );
  return response.data;
},



importHistoricalLeaves: async (file) => {
  if (!file) {
    throw new Error("Veuillez sélectionner un fichier Excel ou CSV.");
  }

  const formData = new FormData();
  formData.append("file", file, file.name);

  const response = await api.post(
    "/leave-requests/import-historical",
    formData
  );

  if (!response.data || typeof response.data !== "object") {
    throw new Error("Réponse invalide du serveur après l'import.");
  }

  console.info("[IMPORT HISTORIQUE] Résultat :", response.data);

  return response.data;
},


};

export default leaveService;